import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  Activity,
  ActivityAction,
} from '../interfaces/activity.interface';




@Injectable({ providedIn: 'root' })
export class ActivityQueueCommunicationService {
  private activitiesSubject = new BehaviorSubject<Activity[] | null>(null);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private activityActionSubject = new Subject<ActivityAction>();

  /**
   * Observable stream of activities for components to subscribe to
   */
  public activities$ = this.activitiesSubject.asObservable();
  
  /**
   * Observable stream of loading state
   */
  public loading$ = this.loadingSubject.asObservable();

  /**
   * Observable stream of activity actions from the activity queue component
   */
  public activityAction$ = this.activityActionSubject.asObservable();

  /**
   * Update the activities list
   */
  updateActivities(activities: Activity[] | null): void {
    this.activitiesSubject.next(activities);
  }

  /**
   * Get current activities snapshot
   */
  getCurrentActivities(): Activity[] | null {
    return this.activitiesSubject.value;
  }

  /**
   * Update loading state
   */
  setLoading(isLoading: boolean): void {
    this.loadingSubject.next(isLoading);
  }

  /**
   * Get current loading state
   */
  isLoading(): boolean {
    return this.loadingSubject.value;
  }

  /**
   * Emit an activity action (used by activity queue component)
   */
  emitActivityAction(action: ActivityAction): void {
    this.activityActionSubject.next(action);
  }

  /**
   * Convenience methods for emitting specific actions
   */
  deleteActivity(activity: Activity): void {
    this.emitActivityAction({ type: 'delete', activity });
  }

  pauseActivity(activity: Activity): void {
    this.emitActivityAction({ type: 'pause', activity });
  }

  resumeActivity(activity: Activity): void {
    this.emitActivityAction({ type: 'resume', activity });
  }

  cancelActivity(activity: Activity): void {
    this.emitActivityAction({ type: 'cancel', activity });
  }
}

